
const data = [
    {
        verizon: "images/Verizon.svg", Airbnb: "images/Airbnb.svg",  Google: "images/Google.svg", Indigo: "images/indigo.svg", Pinterest: "images/Pinterest.svg", Pitch: "images/Pitch.svg", Stripe: "images/Stripe.svg", WeChat: "images/WeChat.svg"
    }
]
const faqdata = [
    {
        id: 1,
        question: "How can I collaborate with teammates ?",
        answer: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi, illum! Minima sapiente distinctio aspernatur, eius magni, placeat aut aliquid error, recusandae assumenda laboriosam provident? Laborum soluta eum magnam excepturi eligendi.'

    },
    {
        id: 2,
        question: "How safe are my clients’ information?",
        answer: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi, illum! Minima sapiente distinctio aspernatur, eius magni, placeat aut aliquid error, recusandae assumenda laboriosam provident? Laborum soluta eum magnam excepturi eligendi.'
        
    },
    {
        id: 3,
        question: "How can I recover lost Information?",
        answer: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi, illum! Minima sapiente distinctio aspernatur, eius magni, placeat aut aliquid error, recusandae assumenda laboriosam provident? Laborum soluta eum magnam excepturi eligendi.'
        
    },
    {
        id: 4,
        question: "Does this software really help manage budget?",
        answer: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi, illum! Minima sapiente distinctio aspernatur, eius magni, placeat aut aliquid error, recusandae assumenda laboriosam provident? Laborum soluta eum magnam excepturi eligendi.'
        
    },
    {
        id: 5,
        question: "How can I upgrade my plan?",
        answer: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi, illum! Minima sapiente distinctio aspernatur, eius magni, placeat aut aliquid error, recusandae assumenda laboriosam provident? Laborum soluta eum magnam excepturi eligendi.'
        
    },
    {
        id: 6,
        question: "How can I collaborate with teammates ?",
        answer: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Commodi, illum! Minima sapiente distinctio aspernatur, eius magni, placeat aut aliquid error, recusandae assumenda laboriosam provident? Laborum soluta eum magnam excepturi eligendi.'
        
    }

]
export default data
export {faqdata}